
import WDElement from '../wd-element';
import WDButton from '../button/wd-button';

export default class WDPillBox extends WDElement
{

  #prefix;
  #suffix;
  #content;

  constructor()
  {
    super().classList.add('wd-pill-box');
  };

  disconnectedCallback()
  {
    super.disconnectedCallback();

    this.offAll();
    this.replaceChildren();
  };

  reset()
  {
    if (this.#prefix) this.#prefix.replaceChildren();
    if (this.#content) this.#content.replaceChildren();
    if (this.#suffix) this.#suffix.replaceChildren();
  };

  get prefix()
  {
    if (!this.#prefix)
    {
      this.#prefix = wdc('<div class="wd-pill-box-prefix"/>');
      this.prepend(this.#prefix);
    }

    return this.#prefix;
  };

  get suffix()
  {
    if (!this.#suffix)
    {
      this.#suffix = wdc('<div class="wd-pill-box-suffix"/>');
      this.append(this.#suffix);
    }

    return this.#suffix;
  };

  get content()
  {
    if (!this.#content)
    {
      this.#content = wdc('<div class="wd-pill-box-content"/>');
      this.append(this.#content);
    }
  
    return this.#content;
  };

  addPill()
  {
    const pill = new WDPill();
    this.add(pill);
    return pill;
  };

  addBox()
  {
    const box = new WDPillBox();
    this.add(box);
    return box;
  };

  add(elem)
  {
    this.content.append(elem);
    return this;
  };

  get items() { return this.content.children; };
  get itemArray() { return [...this.content.children]; };
  itemAt(idx) { return this.items[idx] || null; };
};

export class WDPill extends WDButton
{
  #data;

  constructor(cfg)
  {
    super(cfg).classList.add('wd-pill');
  };

  set content(str)
  {
    this.label = str;
  };

  get content()
  {
    return this.label;
  }

  get box()
  {
    return this.closest('wd-pillbox');
  };

  set data(val)
  {
    this.#data = val;
  };

  get data()
  {
    return this.#data;
  };

}

customElements.define('wd-pillbox', WDPillBox);
customElements.define('wd-pill', WDPill);
